import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BackgroundLayers from "../components/BackgroundLayers";

export default function LegalLayout({ title, kicker, updated, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#F0EAFD] text-[#0F2C5A] overflow-x-hidden">
      <BackgroundLayers />
      <Navbar />
      <main className="relative pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link
              to="/"
              data-testid="legal-back-link"
              className="inline-flex items-center gap-2 text-[12px] tracking-[0.2em] font-bold text-[#3056F5] hover:text-[#0F2C5A] transition-colors mb-8"
            >
              <ArrowLeft className="w-4 h-4" />
              BACK TO QONTRI
            </Link>

            {kicker && (
              <p className="text-[#3056F5] font-bold tracking-[0.35em] text-xs mb-5">
                {kicker}
              </p>
            )}
            <h1
              data-testid="legal-title"
              className="font-display uppercase leading-[0.95] text-[clamp(2.4rem,6vw,4.5rem)] text-[#0F2C5A]"
            >
              {title}
            </h1>
            {updated && (
              <p className="mt-4 text-sm text-[#14254B]/60">{updated}</p>
            )}

            <div
              data-testid="legal-content"
              className="legal-prose mt-12 text-[#14254B] text-base md:text-lg leading-relaxed"
            >
              {children}
            </div>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
